module.exports = "https://static.futunn.com/components/common-offline-activity-session/images/congrate.b10cb2a4bb.png";